<div class="row">
    <div class="col-12 movieTemplate">
        <div class="paneles">
            <div class="row">
                <div class="col-12 px-xl-5">


                    <div class="row">
                        <div class="col-12">
                            <div class="d-flex justify-content-center">
                                <h4 class="my-4 font-weight-bold text-light">¿CÓMO VER +CINEMATECA EN UN TV?
                                </h4>
                            </div>
                            <div>
                                <p class="lead">
                                    Existen varias formas de enviar los videos de +Cinemateca a un televisor moderno con
                                    entrada HDMI o Smart TV. Aquí
                                    explicaremos algunas de estas opciones.
                                </p>
                                <p></p>
                            </div>

                        </div>
                    </div>

                    <div class="card text-white mb-4">
                        <div class="card-body">
                            <div class="titulo">Conectar una laptop a un TV a través de un cable HDMI</div>

                            <p class="texto">Los televisores modernos tienen una entrada HDMI y las laptops una salida
                                del mismo formato. Utilizando un “cable HDMI”
                                se puede enviar la señal desde la laptop hacia el televisor, en este último se deberá
                                seleccionar en el menú de origen
                                de la señal, la opción HDMI (la encontrarás junto a otras que dicen AV1, AV2, VGA, USB,
                                etc).</p>
                        </div>
                    </div>

                    <div class="card text-white mb-4">
                        <div class="card-body">
                            <div class="titulo">Conectar celular a TV por medio de cable MHL activo</div>

                            <p class="texto">Para conectar un celular a la TV con un cable HDMI es importante que tu
                                celular tenga un puerto micro HDMI. Lo único que
                                hay que hacer es conectar el cable MHL activo entre el teléfono celular y la televisión
                                para ver en la tele la pantalla
                                de tu celular inmediatamente.</p>
                        </div>
                    </div>

                    <div class="card text-white mb-4">
                        <div class="card-body">
                            <div class="titulo">Con televisores con Chromecast</div>

                            <p class="texto">El Chromecast es un dispositivo fabricado por la empresa Google que se
                                conecta al puerto HDMI del televisor. Permite
                                reproducir contenido en la TV desde el teléfono, tablet o computadora, aprovechando
                                aplicaciones compatibles. Para
                                usarlo es necesario conectar el dispositivo con la pantalla utilizando la misma red de
                                WiFi.
                            </p>

                            <p>
                                <li>
                                    <b>Desde el celular</b>: existen aplicaciones como Google Home que permiten
                                    duplicar
                                    lo que ves en el celular en la pantalla
                                    de tu televisor.
                                </li>
                                <li><b>Desde la computadora</b>: solo funciona con el navegador Google Chrome, una vez
                                    en el sitio de +Cinemateca, te diriges al menú de tu navegador
                                    (arriba a la derecha) y eliges la opción ENVIAR. La computadora se conectará con tu
                                    Chromecast y podrás ver el contenido
                                    allí.</li>

                            </p>
                        </div>
                    </div>

                    <div class="card text-white mb-4">
                        <div class="card-body">
                            <div class="titulo">Televisores Smart TV</div>

                            <p class="texto">El comportamiento depende del modelo del televisor, en alguno de ellos se
                                puede duplicar la pantalla desde el celular
                                con solo elegir la opción que figura en el celular, en el menú principal como “Enviar”,
                                “Enviar Pantalla”, “Transferir
                                Pantalla” u otros términos similares.</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>